module.exports = "mat-card {\n  margin: 5px;\n  margin-bottom: 0px;\n  padding: 5px\n}\n\nimg {\n  max-width: 40vh;\n  max-height: 40vh\n}\n\n@media only screen and (min-device-width: 481px) {\n  .computer-spacer{\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 1e-09px;\n            flex: 1 1 1e-09px\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bid/bid.component.css
// module id = ./src/app/components/bid/bid.component.css
// module chunks = main